export interface IMerchantProcessingSettings {
  merchantChoiceRouting: IMerchantChoiceRouting;
}

export interface IMerchantChoiceRouting {
  enabled: boolean;
  thresholds?: {
    defaultCardBrand: string;
    minMcrThreshold: string;
  }[];
}
